<template>
  <f7-page @page:init="onPageInit">
    <!-- Top Navbar -->
    <f7-navbar color-theme="orange">
      <f7-nav-left></f7-nav-left>
      <f7-nav-title>微信登录验证</f7-nav-title>
      <langButton></langButton>
    </f7-navbar>
    <f7-block class="text-align-center">
      <f7-preloader color="multi"></f7-preloader>
      <div>微信登录中..</div>
    </f7-block>
  </f7-page>
</template>
<script>
import util from "util/date";
import { weChatCallback } from "@/api/api";
import { f7 } from "framework7-vue";
export default {
  props: {
    f7route: Object,
    f7router: Object,
  },
  data() {
    return {};
  },
  methods: {
    onPageInit() {
      let para = {
        code: this.f7route.query.code,
        state: this.f7route.query.state,
        redirect: this.f7route.params.redirect,
      };
      weChatCallback(para).then((res) => {
        console.log(res.data.response);
        if (res.data.success) {
          f7.store.dispatch(
            "saveOpenId",
            res.data.response.openId
          );
          this.f7router.navigate(res.data.response.redirect);
        }
      });
    },
  },
};
</script>